<template>
  <div class="time-select">
    <div class="detail">
      <div
        class="contentList"
        v-for="(item, key, index) in botData"
        :key="index"
      >
        <div class="text">{{ showbotData(key) }}</div>
        <div
          class="value"
          :class="item.alarm == '0' ? 'normalData-color' : 'alarm-color'"
        >
          {{ showItem(item.value)
          }}<span class="detail-unit-data">{{ showUnit(item.value) }}</span>
        </div>
      </div>
    </div>
    <div class="time-type-select">
      <div
        class="time-type-item"
        :id="timeValue == 'day' ? 'active' : ''"
        @click="changeDay('day')"
      >
        时
      </div>
      <div
        class="time-type-item"
        :id="timeValue == 'month' ? 'active' : ''"
        @click="changeDay('month')"
      >
        日
      </div>
      <div
        class="time-type-item"
        :id="timeValue == 'year' ? 'active' : ''"
        @click="changeDay('year')"
      >
        月
      </div>
    </div>
    <div class="bot-content">
      <custom-charts
        :title="dataBtn"
        :dataList="dataList"
        :timer="timeValue"
      ></custom-charts>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail-timeSelect",
  props: {
    botData: Object,
    timeValue: String,
    dataBtn: String,
    dataList: Object,
  },
  methods: {
    showbotData(val) {
      if (val) {
        if (val == "二氧化碳浓度") {
          return "CO2浓度";
        } else if (val == "一氧化碳浓度") {
          return "CO浓度";
        }
        return val;
      }
    },
    changeDay(value) {
      this.timeValue = value;
      this.$emit("changeDay", this.timeValue);
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      this.historical?.[this.timeValue]?.[this.dataBtn].map((item, index) => {
        let [res] = Object.entries(item);
        this.dataList.x.push(res[0].slice(first, end));
        this.dataList.y.push(res[1]);
      });
    },
    showItem(val) {
      if (val) {
        if (val.includes(".")) {
          return val.split(".")[0] + "." + val.split(".")[1].slice(0, 2);
        } else if (val == "暂无数据") {
          return "-";
        } else {
          return val;
        }
      }
      if (val == 0) {
        return "0";
      }
    },
    showUnit(val) {
      if (val.includes(".")) {
        return val.split(".")[1].slice(2);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  display: grid;
  grid-template-columns: 160px 160px;
  // grid-template-rows: repeat(5, 29px);
  gap: 4px 20px;
  overflow: hidden;
  .contentList {
    padding: 4px 10px;
    display: flex;
    justify-content: space-between;
    width: 160px;
    font-size: 14px;
    color: rgba(239, 239, 239, 0.7);
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    .text {
      width: 60px;
      white-space: nowrap;
    }
    .value {
      font-size: 14px;
      line-height: 20.72px;
    }
    .normalData-color {
      color: #fff;
    }
    .alarm-color {
      color: #f1802f;
    }
  }
}
.time-type-select {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .time-type-item {
    margin-right: 7px;
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .time-type-item:last-child {
    margin-right: 0;
  }
  #active {
    background: rgba(175, 175, 175, 0.2);
  }
}
.bot-content {
  margin-top: 15px;
  width: 341px;
  height: 140px;
}
</style>
